import { render } from "./PhotoAlbumOverview.vue?vue&type=template&id=1bfa8964&ts=true"
import script from "./PhotoAlbumOverview.vue?vue&type=script&lang=ts"
export * from "./PhotoAlbumOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/data/home/cazaleres/application/cazaleres-owner/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QIcon});
